import { type FC } from "react";
import { cassetteHeading } from "../../styles.css";

export type RelatedHeaderProps = {
  businessType: string;
  occupation: string;
};

export const RelatedHeader: FC<RelatedHeaderProps> = ({ businessType, occupation }) => (
  <h3 className={cassetteHeading}>
    {businessType}│<span>{occupation}</span>
  </h3>
);
